// Mock data for Hallstatt ceramic machinery website

export const products = [
  {
    id: 1,
    name: "Prensa Hidráulica Industrial",
    description: "Prensa de alta precisión para moldeado cerámico",
    image: "https://images.unsplash.com/photo-1764114440403-4dd539cb582a",
    specs: "Capacidad: 500 ton, Control digital"
  },
  {
    id: 2,
    name: "Sistema de Tuberías y Válvulas",
    description: "Sistema completo de transporte de materiales",
    image: "https://images.pexels.com/photos/17728787/pexels-photo-17728787.jpeg",
    specs: "Acero inoxidable, Control automatizado"
  },
  {
    id: 3,
    name: "Mezcladora Industrial",
    description: "Mezcladora de alta capacidad para arcillas",
    image: "https://images.pexels.com/photos/6611182/pexels-photo-6611182.jpeg",
    specs: "Capacidad: 1000L, Motor trifásico"
  },
  {
    id: 4,
    name: "Torno Industrial CNC",
    description: "Torno de precisión con control numérico",
    image: "https://images.unsplash.com/photo-1764114441097-6a475eca993d",
    specs: "CNC, Alta precisión, Automatizado"
  },
  {
    id: 5,
    name: "Extrusora de Cerámica",
    description: "Extrusora continua para perfiles cerámicos",
    image: "https://images.unsplash.com/photo-1767281075989-7571356d477e",
    specs: "Producción continua, Control de velocidad"
  },
  {
    id: 6,
    name: "Línea de Producción Automatizada",
    description: "Sistema completo de fabricación moderna",
    image: "https://images.pexels.com/photos/4225118/pexels-photo-4225118.jpeg",
    specs: "Automatización completa, Industria 4.0"
  },
  {
    id: 7,
    name: "Cortadora de Precisión",
    description: "Cortadora láser para piezas cerámicas",
    image: "https://images.unsplash.com/photo-1758271141001-e4ff47f2b1c5",
    specs: "Corte láser, Alta precisión"
  },
  {
    id: 8,
    name: "Horno Industrial",
    description: "Horno de alta temperatura para cocción",
    image: "https://images.unsplash.com/photo-1771523353042-981551738dd7",
    specs: "Hasta 1400°C, Control programable"
  },
  {
    id: 9,
    name: "Pulidora Automática",
    description: "Sistema automatizado de pulido y acabado",
    image: "https://images.unsplash.com/photo-1644463631960-8b2455a4f772",
    specs: "Acabado profesional, Velocidad variable"
  },
  {
    id: 10,
    name: "Secadora Industrial",
    description: "Secadora de gran capacidad para piezas",
    image: "https://images.unsplash.com/photo-1557644978-f61037cfbe49",
    specs: "Control de humedad, Eficiencia energética"
  }
];

export const companyInfo = {
  name: "Hallstatt",
  tagline: "Fabricación de Maquinaria para Cerámica",
  description: "Diseño y fabricación propia. Robustez y precisión para talleres y fábricas cerámicas.",
  whatsapp: "+5491167667569",
  email: "contacto@hallstatt.com",
  phone: "+54 911 6766 7569",
  instagram: "https://instagram.com/hallstatt",
  facebook: "https://facebook.com/hallstatt",
  heroImage: "https://images.unsplash.com/photo-1697281679290-ad7be1b10682",
  workshopImage: "https://images.pexels.com/photos/3544567/pexels-photo-3544567.jpeg"
};

export const aboutText = {
  title: "Sobre Nosotros",
  content: "Somos fabricantes locales de maquinaria industrial para cerámica con más de 15 años de experiencia en el sector. Diseñamos y fabricamos cada máquina con los más altos estándares de calidad, utilizando materiales premium y tecnología de punta. Nuestro compromiso es brindar soluciones robustas y precisas que optimicen la producción en talleres y fábricas cerámicas de toda la región."
};
